import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  "wire:loading": "",
  class: "jr-root jr-fixed jr-top-0 jr-left-0 jr-right-0 jr-bottom-0 jr-w-full jr-h-screen jr-z-50 jr-overflow-hidden jr-flex jr-flex-col jr-items-center jr-justify-center"
}
const _hoisted_2 = { class: "jr-fixed-box jr-fixed jr-flex-col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "jr-loader jr-ease-linear jr-rounded-full jr-border-4 jr-border-t-4 jr-border-gray-200 jr-h-12 jr-w-12 jr-mb-4" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "jr-text-s jr-text-dark flex-1 jr-mt-6" }, "ただいま可視化中", -1)
const _hoisted_5 = {
  key: 0,
  class: "jr-text-s jr-text-dark flex-1 jr-px-5 jr-mt-1 jr-text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (_ctx.isArea)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, "データ量が多い場合は数分を要する場合があります"))
        : _createCommentVNode("", true)
    ])
  ]))
}